import { render, staticRenderFns } from "./ProductApplications.vue?vue&type=template&id=58c63f97&"
import script from "./ProductApplications.vue?vue&type=script&lang=ts&"
export * from "./ProductApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports